import axios from "axios";

axios.defaults.headers.common.Authorization = ``;
export default axios;
